import React from "react";

const OrderDetailsPrimaryInfo = ({ data }) => {
  return (
    <>
      <div className="space-y-6">
        <div className="max-w-60">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            {data?.bookData?.title}
          </div>
          <div className="text-xs 2xl:text-sm text-slate-500 !leading-none mt-1 tracking-wide">
            {data?.bookData?.description}
          </div>
        </div>
        <div className="space-y-0.5">
          <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
            Number of Files
          </div>
          <div className="text-sm 2xl:text-base font-medium !leading-none">
            {data?.items?.length}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetailsPrimaryInfo;
